import React from 'react'
import BreadCrumb from '../../../components/BreadCrumb'

export default function MediaBanner({ breadcrumb }) {
  return (
    <>
      <section className='mediabanner-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-8 col-sm-9'>
              {breadcrumb && <BreadCrumb data={breadcrumb} />}
              <h1 className='heading'>What's Happening at Mobility Infotech</h1>
              <p>Catch the latest press coverage, product news, and milestones shaping the future of logistics.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
